<template>
  <img src="@/assets/book.svg" alt="book-icon" height="100%" />
</template>
